module.exports = __webpack_public_path__ + "MaterialIcons-Regular.012cf6a10129e2275d79.woff";


//////////////////
// WEBPACK FOOTER
// /Users/erikh/GitHub/Brickchain/oidc-demo/frontend/src/assets/fonts/MaterialIcons-Regular.woff
// module id = ../../../../../src/assets/fonts/MaterialIcons-Regular.woff
// module chunks = styles